'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { createElement } from '@emotion/react';
import { forwardRef } from 'react';
import { Box } from '@s7/base';
import { useComponentDefaultProps } from '@s7/styles';
import { COMPONENT_ID, defaultProps } from './Skeleton.contract.js';
import useStyles from './Skeleton.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Skeleton = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _useComponentDefaultProps = useComponentDefaultProps(COMPONENT_ID, defaultProps, props), variant = _useComponentDefaultProps.variant, size = _useComponentDefaultProps.size, color = _useComponentDefaultProps.color, accentColor = _useComponentDefaultProps.accentColor, lines = _useComponentDefaultProps.lines, spacing = _useComponentDefaultProps.spacing, align = _useComponentDefaultProps.align, visible = _useComponentDefaultProps.visible, height = _useComponentDefaultProps.height, width = _useComponentDefaultProps.width, radius = _useComponentDefaultProps.radius, animate = _useComponentDefaultProps.animate, animation = _useComponentDefaultProps.animation, animationOptions = _useComponentDefaultProps.animationOptions, typography = _useComponentDefaultProps.typography, textAlign = _useComponentDefaultProps.textAlign, styles = _useComponentDefaultProps.styles, classNames = _useComponentDefaultProps.classNames, className = _useComponentDefaultProps.className, theme = _useComponentDefaultProps.theme, others = _object_without_properties_loose(_useComponentDefaultProps, [
        "variant",
        "size",
        "color",
        "accentColor",
        "lines",
        "spacing",
        "align",
        "visible",
        "height",
        "width",
        "radius",
        "animate",
        "animation",
        "animationOptions",
        "typography",
        "textAlign",
        "styles",
        "classNames",
        "className",
        "theme"
    ]);
    var asStack = Boolean(lines);
    var _useStyles = useStyles({
        params: {
            height: height,
            width: width,
            radius: radius,
            color: color,
            accentColor: accentColor,
            animate: animate,
            animation: animation,
            animationOptions: animationOptions,
            typography: typography,
            textAlign: textAlign,
            align: align,
            spacing: spacing,
            asStack: asStack
        },
        options: {
            name: COMPONENT_ID,
            styles: styles,
            classNames: classNames,
            variations: {
                variant: variant,
                size: size
            }
        },
        theme: theme
    }), classes = _useStyles.classes, cx = _useStyles.cx;
    if (asStack) {
        var elements = [].concat(Array(lines).keys());
        return /*#__PURE__*/ jsx(Box, {
            ref: ref,
            className: classes.stack,
            children: elements.map(function(key) {
                var _obj;
                return /*#__PURE__*/ createElement(Box, _extends({
                    className: cx(classes.root, (_obj = {}, _obj[classes.visible] = visible, _obj), className),
                    as: "span"
                }, others, {
                    key: "skeleton-line-" + key
                }));
            })
        });
    }
    var _obj;
    return /*#__PURE__*/ jsx(Box, _extends({
        ref: ref,
        className: cx(classes.root, (_obj = {}, _obj[classes.visible] = visible, _obj), className),
        as: "span"
    }, others));
});
var Skeleton$1 = Skeleton;
Skeleton.displayName = COMPONENT_ID;

export { Skeleton, Skeleton$1 as default };
